export enum commonTabs {
  overview = 'Overview',
  profile = 'Profile',
  progressNote = 'Progress Note',
  patientNote = 'Patient Notes',
  data = 'Data',
  courses = 'Home Exercise Program',
  documentation = 'Documentation',
  generalInfo = 'Administrative',
  rtm = 'RTM',
  activityLogPage = 'Activity Log',
  balanceDemo = 'Balance (Demo)',
}

export enum patientTabsUrl {
  overview = '/',
  patientNote = 'patient_note',
  profile = 'profile',
  data = 'data',
  courses = 'homeExerciseProgram',
  documentation = 'documentation',
  rtm = 'rtm',
  activityLog = 'progress',
  balanceDemo = 'balance',
}
